import { PageHeaderBackButton } from "@fp/ui/components/base/page-layout/page-layout";
import { useNavigate, useRouterState } from "@tanstack/react-router";

export type PageTarget = {
  url: string;
  label: string;
};

export function PageBackButton({
  fallbackUrl,
  children,
}: {
  fallbackUrl: string;
  children?: React.ReactNode;
}) {
  const navigate = useNavigate();
  const routerState = useRouterState();

  const { returnTo, returnLabel } = routerState.location.state;
  const cameFrom =
    returnTo && returnTo !== routerState.location.href ? returnTo : undefined;

  const backUrl = cameFrom ?? fallbackUrl;
  const label = cameFrom ? (returnLabel ?? children) : children;

  return (
    <PageHeaderBackButton onBack={() => navigate({ to: backUrl })}>
      {label}
    </PageHeaderBackButton>
  );
}
